/** Pointer travel in CSS pixels beyond which a press counts as a drag, not a click. */
const CLICK_SLOP_PX = 5;

/** True when the pointer moved at most CLICK_SLOP_PX between pointerdown and click. */
export function isClick(downX: number, downY: number, x: number, y: number): boolean {
  return Math.hypot(x - downX, y - downY) <= CLICK_SLOP_PX;
}
